module.exports = __webpack_public_path__ + "static/media/governance.e38743e4.svg";